import { appQueryClient } from "$src/application/main/queryClient";
import { ServiceTokens } from "$src/domain/ServiceTokens";
import type { IProjectRepository } from "$src/domain/projects/IProjectRepository";
import { ProjectIdentifier } from "$src/domain/projects/ProjectIdentifier";
import { inject, injectable } from "tsyringe";

@injectable()
export class OrderProject {
    
    constructor(@inject(ServiceTokens.ProjectService) private projectRepository: IProjectRepository) {}

    async execute(groupStoreId: number, projectId: number): Promise<ProjectIdentifier> {

        var identifier = await this.projectRepository.orderProject(groupStoreId, projectId);

        appQueryClient.invalidateQueries(['project', groupStoreId, projectId], { refetchActive: true });
        
        return identifier;
    }
}

export const OrderProjectToken = Symbol('OrderProjectToken');